'use strict';
$(document).ready(function() {

    // Așteaptă puțin pentru a fi sigur că toate elementele sunt încărcate
    setTimeout(function() {
        manageDeleteButtons();
    }, 100);
});


function syncTableVisibility() {
    var $tbody = $('#add-to-transfer-materials-container');
    var $table = $('#add_to_transfer_table');
    var $tableAddButton = $('#transfer_material_add_materials');
    var $tableDeleteButton = $('#transfer_material_delete_materials');

    var visibleRows = $tbody.find('tr').filter(function () {
        return $(this).css('display') !== 'none';
    });

    if (visibleRows.length > 0) {
        $table.show();
        $tableAddButton.show();
        $tableAddButton.css('margin-right', "5px");
        $tableDeleteButton.show();
    } else {
        $table.hide();
        $tableAddButton.hide();
        $tableDeleteButton.hide();
    }
}

/**
 * Gestionează afișarea butoanelor de delete
 * - Dacă există un singur rând rămas, ascunde butonul de delete
 * - Dacă există mai multe rânduri, arată butoanele de delete pe toate
 */
function manageDeleteButtons() {
    const $tbody = $('#to-transfer-materials-container');

    // Verifică dacă tbody-ul există
    if ($tbody.length === 0) {
        return;
    }

    const $visibleRows = $tbody.find('tr').filter(function() {
        return $(this).css('display') !== 'none';
    });

    const countRows = $visibleRows.length;

    if (countRows === 1) {
        // Un singur rând rămas - ascunde butonul de delete
        $visibleRows.find('.delete-param').hide();
    } else {
        // Mai multe rânduri sau niciunul - arată butoanele de delete pe toate
        $tbody.find('.delete-param').show();
    }
}

/**
 * Sincronizează vizibilitatea tabelului de materiale
 */
function syncMainTableVisibility() {
    var $tbody = $('#add-to-transfer-materials-container');
    var $table = $('#add_to_transfer_table');
    var $tableAddButton = $('#transfer_material_add_materials');
    var $tableDeleteButton = $('#transfer_material_delete_materials');

    var visibleRows = $tbody.find('tr').filter(function() {
        return $(this).css('display') !== 'none';
    });

    if (visibleRows.length > 0) {
        $table.show();
        $tableAddButton.show();
        $tableAddButton.css('margin-right', "5px");
        $tableDeleteButton.show();
    } else {
        $table.hide();
        $tableAddButton.hide();
        $tableDeleteButton.hide();
    }
}

function deleteRow(buttonElement, idMaterial = '') {

    const rowElement = $(buttonElement).closest('tr');

    if (!confirm('Sigur doriti sa stergeti acest rand?')) {
        return;
    }

    if (idMaterial !== '') {
        // ========== CU idMaterial: Ascunde rândul (se șterge din DB) ==========
        rowElement.find('.itemStatus').text('0');
        rowElement.hide();

        $('.btn-primary').prop('disabled', true).addClass('disabled');
        $('.btn-danger').prop('disabled', true).addClass('disabled');

        $.ajax({
            url: '/materialtransfer/deleteMaterial',
            method: 'POST',
            data: {
                idMaterial: idMaterial
            },
            success: function(response) {
                // După ștergerea cu succes, verifică dacă trebuie ascuns butonul de delete
                manageDeleteButtons();
                location.reload();
            },
            error: function(xhr, status, error) {
                $('.btn-primary').prop('disabled', false).removeClass('disabled');
                $('.btn-danger').prop('disabled', false).removeClass('disabled');
                console.error('Eroare la stergerea materialului:', error);
                alert('A apărut o eroare la ștergerea materialului! ' + xhr.responseText);

                // La eroare, readucem rândul vizual
                rowElement.find('.itemStatus').text('1');
                rowElement.show();
            }
        });

    } else {
        // ========== FARA idMaterial: Șterge complet randul din DOM ==========
        rowElement.remove();
    }

    // Sincronizează vizibilitatea tabelului
    syncTableVisibility();
}



(function(z, Backbone, Translator){

    var TransferMaterialImportForm = Backbone.View.extend({

        el: '#import-transferMaterials-panel',

        UPLOAD_MAX_SIZE: 10000000,
        UPLOAD_ALLOWED_TYPES: [
            'text/csv',
            'text/plain',
            'application/vnd.ms-excel'
        ],

        events: {
            'click #transfer-material-import-upload-button': '_onUploadClick'
        },

        initialize: function() {
            this._bindModel();
            this._bindEvents();
        },

        _bindModel: function(model){
            model = _.isUndefined(model) ? this.model : model;
            Backbone.Validation.unbind(this, {model: model});
            Backbone.Validation.bind(this, {
                valid: this._onValid.bind(this),
                invalid: this._onInvalid.bind(this),
                model: model
            });
        },

        _bindEvents: function(){
            this.listenTo(this.model, 'request', this._onModelRequest);
            this.listenTo(this.model, 'sync', this._onModelSync);
            this.listenTo(this.model, 'error', this._onModelError);
        },

        syncTableVisibility: function() {
            var $tbody = $('#add-to-transfer-materials-container');
            var $table = $('#add_to_transfer_table');
            var $tableAddButton = $('#transfer_material_add_materials');
            var $tableDeleteButton = $('#transfer_material_delete_materials');

            var visibleRows = $tbody.find('tr').filter(function() {
                return $(this).css('display') !== 'none';
            });

            if (visibleRows.length > 0) {
                $table.show();
                $tableAddButton.show();
                $tableAddButton.css('margin-right',"5px");
                $tableDeleteButton.show();
            } else {
                $table.hide();
                $tableAddButton.hide();
                $tableDeleteButton.hide();
            }
        },

        _onUploadClick: function (e) {

            e.preventDefault();

            if (document.getElementById("transfer_material_form_type") != null)
            {
                var transferType = document.getElementById("transfer_material_form_type").value;
                var idProject = document.getElementById("transfer_material_form_idProject").value;
                var technician = document.getElementById("transfer_material_form_technician").value;
                var division = document.getElementById("transfer_material_form_division").value;

                // VALIDARI
                if (!transferType) {
                    alert("Selecteaza tipul de transfer.");
                    return;
                }

                if (transferType == 4 && !technician) {
                    alert("Selecteaza tehnicianul.");
                    return;
                }

                if (transferType == 5 && !division) {
                    alert("Selecteaza Divizia Marketplace.");
                    return;
                }

                if ((transferType == 1 || transferType == 2 || transferType == 3 || transferType == 5) && !idProject) {
                    alert("Introdu ID-ul de proiect.");
                    return;
                }
            }

            const fileInput = document.getElementById('import-template-field');

            if (!fileInput.files.length) {
                alert('Selecteaza un fisier CSV');
                return;
            }

            const file = fileInput.files[0];
            const reader = new FileReader();

            reader.onload = (event) => {

                const csv = event.target.result.trim();
                const rows = csv.split(/\r?\n/);
                const delimiter = rows[0].includes(';') ? ';' : ',';
                rows.shift();

                let container = document.querySelector('#to-transfer-materials-container');

// ========== FAZA 1: VALIDARE COMPLETĂ - colectează TOATE erorile ==========
                let errors = [];

                rows.forEach((row, index) => {
                    if (!row.trim()) return;

                    const cols = row.split(delimiter);
                    const pn = cols[0] || '';
                    const gestiune = cols[2] || '';
                    const cantitateStoc = parseFloat(cols[3]) || 0;
                    const cantitate = parseFloat(cols[4]) || 0;
                    const rowNumber = index + 1;

                    // Verificare cantitate stoc vs cantitate cerută
                    if (cantitateStoc < cantitate) {
                        errors.push('✘ Randul ' + rowNumber + ' - PN: ' + pn + ': cantitatea ceruta (' + cantitate + ') depaseste stocul disponibil (' + cantitateStoc + ')');
                        // return;
                    }

                    // Verificare dacă materialul există deja în tabel - verifică data-max
                    let containerTr = '#to-transfer-materials-container';
                    if ($('#transfer_id-field').length > 0) {
                        containerTr = '#add-to-transfer-materials-container';
                    }

                    let existingPnImportRow = null;
                    $(containerTr + ' tr').each(function() {
                        var $r = $(this);
                        var rowPn = $r.find('td').eq(0).text().trim();
                        var rowWh = $r.find('td').eq(3).text().trim();
                        if (rowPn === pn.trim() && rowWh === gestiune.trim()) {
                            existingPnImportRow = $r;
                            return false;
                        }
                    });

                    if (existingPnImportRow) {
                        const currentQty = parseFloat(existingPnImportRow.find('td').eq(4).text()) || 0;
                        const qt = currentQty + cantitate;
                        const maxQty = parseFloat(existingPnImportRow.attr('data-max')) || 0;

                        if (qt > maxQty) {
                            errors.push('✘ Randul ' + rowNumber + ' - PN: ' + pn + ': cantitatea totala (' + qt + ') depaseste stocul maxim disponibil (' + maxQty + ')');
                        }
                    }
                });

                if (errors.length > 0) {

                    this._showExtraError(errors.join('<br>'));
                    fileInput.value = '';
                    return;
                }

                $('#transfer_create_table caption').html('');

                rows.forEach((row, index) => {
                    if (!row.trim()) return;

                    const cols = row.split(delimiter);
                    const pn = cols[0] || '';
                    const denumire = cols[1] || '';
                    const gestiune = cols[2] || '';
                    const cantitateStoc = cols[3] || '';
                    const cantitate = cols[4] || '';
                    const pret = cols[5] || '';
                    const supplier = cols[6].replace(/\"/g, "") || '';
                    const batch = cols[7] || '';
                    const partida = cols[8] || '';

                    let containerTr = '#to-transfer-materials-container';

                    if ($('#transfer_id-field').length > 0) {
                        containerTr = '#add-to-transfer-materials-container';
                        container = document.querySelector('#add-to-transfer-materials-container');
                    }

                    let existingPnImportRow = null;
                    $(containerTr + ' tr').each(function() {
                        var $r = $(this);
                        var rowPn = $r.find('td').eq(0).text().trim();
                        var rowWh = $r.find('td').eq(3).text().trim();
                        if (rowPn === pn.trim() && rowWh === gestiune.trim()) {
                            existingPnImportRow = $r;
                            return false;
                        }
                    });

                    let newRow = '';
                    if (existingPnImportRow) {
                        var currentImportQty = parseFloat(existingPnImportRow.find('td').eq(4).text()) || 0;
                        var qt = currentImportQty + parseFloat(cantitate);
                        existingPnImportRow.find('td').eq(4).text(qt);
                        existingPnImportRow.attr('data-modified', '1');
                    } else {
                        newRow =
                            '<tr data-modified="1" data-max="' + cantitateStoc + '">' +
                            '<td>' + pn + '</td>' +
                            '<td>' + denumire + '</td>' +
                            '<td></td>' +
                            '<td>' + gestiune + '</td>' +
                            '<td>' + cantitate + '</td>' +
                            '<td>' + pret + '</td>' +
                            '<td>' + supplier + '</td>' +
                            '<td>' + batch + '</td>' +
                            '<td>' + partida + '</td>' +
                            '<td class="itemStatus" style="display: none">1</td>' +
                            '<td class="text-center">' +
                            '<a onclick="deleteRow(this)" class="btn btn-danger btn-xs delete-param"><i class="fa fa-trash"></i></a>' +
                            '</td>' +
                            '</tr>';
                    }

                    container.insertAdjacentHTML('beforeend', newRow);

                });

                this.syncTableVisibility();

                // După adăugare, gestionează butoanele de delete (le arată pe toate)
                if (typeof manageDeleteButtons === 'function') {
                    manageDeleteButtons();
                }

                // ========== ELIBEREAZA FILE INPUT DUPA PROCESARE ==========
                fileInput.value = '';
            };

            reader.readAsText(file);
        },

        _hideExtraSuccess: function(){

            var $error = this.$('#transfer-success-message');

            $error
                .finish()
                .fadeOut(0)
                .addClass('hidden');
        },

        /**
         * Display the error message
         * @param {string} message The message to be displayed
         * @return {undefined}
         * @private
         */
        _showExtraError: function(message){

            this._hideExtraSuccess();

            var $error = $('#transfer-error-message');

            $error
                .html(message)
                .removeClass('hidden')
                .fadeOut(0)
                .fadeIn('slow')
                .delay(5000)
                .fadeOut('slow', function(){

                    $error.addClass('hidden');
                });
        },

        /**
         * Hide the error message
         * @return {undefined}
         * @private
         */
        _hideExtraError: function(){

            var $error = $('#transfer-error-message');

            $error
                .finish()
                .fadeOut(0)
                .addClass('hidden');
        },

        /**
         * Display the success message
         * @param {string} message The message to be displayed
         * @return {undefined}
         * @private
         */
        _showExtraSuccess: function(message){

            this._hideExtraError();

            var $success = $('#transfer-success-message');

            $success
                .html(message)
                .removeClass('hidden')
                .fadeOut(0)
                .fadeIn('slow')
                .delay(5000)
                .fadeOut('slow', function(){

                    $success.addClass('hidden');
                });
        },

        _deleteRow() {

            this.remove();
        },

        _onValid: function(view, attr){
            var $form = this.$('form');
            $form.find('[data-validation="' + attr + '"]')
                .removeClass('has-error')
                .find('.help-block')
                .addClass('hidden')
                .text('');
        },

        _onInvalid: function(view, attr, error){
            var $form = this.$('form');
            $form.find('[data-validation="' + attr + '"]')
                .addClass('has-error')
                .find('.help-block')
                .removeClass('hidden')
                .text(error);
        },

        _onModelRequest: function(){
            this._setLoading(true);
        },

        _onModelSync: function(){
            this._setLoading(false);
        },

        _onModelError: function(model, res){
            this._setLoading(false);
        },

        _uploadTemplate: function(){
            this._setLoading(true);
            var data = this._getFormData(this.model);

            Backbone.ajax({
                url: '/material/import',
                type: 'POST',
                data: data,
                processData: false,
                contentType: false,
                success: function(res) {
                    this._setLoading(false);

                    var data = res.data || {};
                    var errors = res.errors || [];

                    if (!data.inserted && !data.updated && !data.total) {
                        errors.push("Importul de piese a esuat.");
                    }

                    this._showImportMessages(data, errors);
                    this._resetForm();
                }.bind(this),
                error: function(xhr){
                    this._setLoading(false);
                    var errors = [];
                    if (xhr.responseJSON && xhr.responseJSON.errors) {
                        errors = xhr.responseJSON.errors.map(e => e.message);
                    } else {
                        errors.push("Eroare la import. Verificați fișierul!");
                    }
                    this._showImportMessages({}, errors);
                }.bind(this)
            });
        },

        _resetForm: function(){
            this.$('form').get(0).reset();
        },

        _getFormData: function(){
            var data = new FormData();
            var fileInput = document.querySelector('#import-template-field');
            var typeSelect = document.querySelector('#import-type-field');
            if (fileInput && fileInput.files.length > 0) {
                data.append('material_import_form[template]', fileInput.files[0]);
            }
            if (typeSelect && typeSelect.value) {
                data.append('material_import_form[type]', typeSelect.value);
            }
            return data;
        },

        _isValidUploadType: function(type){
            return this.UPLOAD_ALLOWED_TYPES.indexOf(type) >= 0;
        },

        _isValidUploadSize: function(size){
            return size <= this.UPLOAD_MAX_SIZE;
        },

        _setLoading: function(loading){
            var $spinner = this.$('#import-loading');
            if (loading) {
                $spinner.show();
            } else {
                $spinner.hide();
            }
        },

        _showImportMessages: function(data, errors){
            var $error = this.$('#import-errors-holder');
            $error.empty();

            if (errors && errors.length) {
                errors.forEach(function(msg){
                    $('<span>').addClass('help-block text-left text-danger').text(msg).appendTo($error);
                });
                this.$('#import-errors').removeClass('hidden').fadeIn('slow');
            }

            if (data && (data.inserted || data.updated || data.total)) {
                var successMsg = 'Import reușit: ' +
                    (data.inserted ? data.inserted + ' adăugate, ' : '') +
                    (data.updated ? data.updated + ' modificate, ' : '') +
                    (data.total ? 'total ' + data.total : '');
                var $success = $('#import-success-message');
                // if ($success) {
                $success = $('<div id="import-success-message" class="alert alert-success text-left mt-2 hidden"></div>');
                this.$el.prepend($success);
                // }
                $success.text(successMsg)
                    .removeClass('hidden')
                    .fadeOut(0).fadeIn('slow')
                    .delay(5000)
                    .fadeOut('slow', function(){ $success.addClass('hidden'); });
            }
        },

        _hideMessages: function(){
            this.$('#import-errors').addClass('hidden').fadeOut('fast');
            var $success = $('#import-success-message');
            $success.addClass('hidden').hide();
        },

        _showError: function(message){
            var $error = $('#import-error-message');
            if (!$error.length) {
                $error = $('<div id="import-error-message" class="alert alert-danger text-left mt-2 hidden"></div>');
                this.$el.prepend($error);
            }
            $error.text(message)
                .removeClass('hidden')
                .fadeOut(0).fadeIn('slow')
                .delay(4000)
                .fadeOut('slow', function(){ $error.addClass('hidden'); });
        }

    });

    z.TransferMaterialImportForm = TransferMaterialImportForm;

})(window.z = window.z || {}, Backbone, Translator);
